<template>
  <div 
    class="border rounded border-left-4 mb-3"
    :class="{ 
      'bg-orange-light': isRPPS,
      'border-orange': isRPPS,
      'border-info': !isRPPS
    }"
  >
    <div class="p-2 border-bottom d-flex align-items-center">
      <div>
        <h6 class="mb-2 text-gray-600 font-weight-bold">
          <i
            v-if="hasMinSalaryWarnings"
            class="fa fa-exclamation-triangle text-warning mr-1"
            aria-hidden="true"
            v-b-tooltip.hover
            title="Atenção, competências abaixo do salário-mínimo. Verificar necessidade de complementação."
          ></i>
          <i
            v-if="showRuralRppsWarning"
            class="fa fa-exclamation-triangle text-warning mr-1"
            aria-hidden="true"
            v-b-tooltip.hover
            title="ATENÇÃO: tempo rural utilizado no RPPS deve ser comprovado e indenizado no RGPS."
          ></i>
          <i class="fa fa-building mr-1" aria-hidden="true"></i>
          {{item.companyName}}
        </h6>
        <h6 class="mb-0 small text-gray-600">
          Período de {{ duration }} <i class="fa fa-info-circle text-info" v-if="rgpsWarning" aria-hidden="true" v-b-tooltip.hover title="Período computado conforme disposto no Art. 19-C, §2º do Decreto nº 3.048/99, com redação pelo Decreto nº 10.410/2020"></i>
        </h6>
        <div class="mt-1 mr-1">
          <span 
            v-for="tag, index in tags" :id="'tooltip-target-'+index" :key="'tooltip-target-'+index"
            class="badge badge-pill mr-1"
            :class="[isRPPS ? 'badge-orange' : 'badge-info']"
          >
            {{ tag.name }}
          </span>
        </div>
        <div v-if="item.observation">
          <h6 class="mt-1 small text-gray-600">
            <i class="fa fa-info-circle text-info mr-1" aria-hidden="true"></i>
            {{item.observation}}
          </h6>
        </div>
      </div>

      <div class="ml-auto"></div>

      <div class="d-flex align-items-center mr-1">
        <span class="mr-2 small text-gray-600">RGPS</span>
        <b-form-checkbox
          v-model="isRPPS"
          switch
          @change="handleRegimeTypeChange"
        ></b-form-checkbox>
        <span class="ml-1 small text-gray-600">RPPS</span>
      </div>

      <button
        class="btn btn-link p-0 btn-sm ml-4"
        title="Adições"
        v-on:click="$emit('addition', item)"
        v-if="canAddition"
        :class="{ 'text-orange': isRPPS }"
      >
        Adições
      </button>

      <button
        class="btn btn-link p-0 btn-sm ml-4"
        title="Deduções"
        v-on:click="$emit('deduction', item)"
        :class="{ 'text-orange': isRPPS }"
      >
        Deduções
      </button>

      <button
        class="btn btn-link p-0 btn-sm ml-4"
        title="Dividir Vínculo"
        v-on:click="$emit('divide', item)"
        :class="{ 'text-orange': isRPPS }"
      >
        <i class="fa fa-scissors" aria-hidden="true"></i>
      </button>

      <button
        class="btn btn-link p-0 btn-sm ml-4"
        title="Editar"
        v-on:click="$emit('edit', item)"
        :class="{ 'text-orange': isRPPS }"
      >
        <i class="fa fa-edit" aria-hidden="true"></i>
      </button>

      <button
        class="btn btn-link text-danger p-0 btn-sm ml-4"
        title="Remover"
        v-on:click="$emit('remove', item)"
      >
        <i class="fa fa-trash" aria-hidden="true"></i>
      </button>
    </div>

    <div>
      <div class="row align-items-center">
        <div class="col-md-3 border-right">
          <div class="p-2">
            <h6 class="text-uppercase text-gray-600 small">Ingresso</h6>
            <h6 class="text-info mb-0" :class="{ 'text-orange': isRPPS }">
              <i class="fa fa-calendar-check-o mr-1" aria-hidden="true"></i>
              {{ ingressDate }}
              <!-- {{item.ingressDate | moment('DD/MM/YYYY')}} -->
            </h6>
          </div>
        </div>
        <div class="col-md-3 border-right">
          <div class="p-2">
            <h6 class="text-uppercase text-gray-600 small">Encerramento</h6>
            <h6 class="text-info mb-0" :class="{ 'text-orange': isRPPS }">
              <i class="fa fa-calendar-times-o mr-1" aria-hidden="true"></i>
              {{ egressDate }}
              <!-- {{item.egressDate | moment('DD/MM/YYYY')}} -->
            </h6>
          </div>
        </div>

        <div class="col-md-6">
          <div class="p-2">
            <div
              class="d-flex align-items-center mb-1"
              v-if="fillPercentage <= 100"
            >
              <h6 class="text-uppercase text-gray-600 small mb-0">Remunerações preenchidas</h6>

              <span
                class="text-uppercase small font-weight-bold ml-1 text-gray-600"
              >
                {{ fillNumber }} de {{ total }}
              </span>

              <span
                class="ml-1 font-weight-bold small"
                v-bind:class="!isRPPS ? 'text-info': 'text-secondary'"
              >
                ({{fillPercentage}}%)
              </span>

              <button
                class="btn btn-sm ml-auto px-1 py-0"
                v-bind:class="!isRPPS ? 'btn-outline-info': 'btn-outline-secondary'"
                v-on:click="$emit('addRemuneration', item)"
              >
                <i class="fa fa-plus" aria-hidden="true"></i>
                Inserir
              </button>
            </div>
            <div class="d-flex align-items-center mb-1" v-else>
              <i class="fa fa-exclamation-triangle text-warning mr-1" aria-hidden="true"></i>
              <h6 class="text-error bold mb-0">Data de início e término inválidas</h6>
            </div>

            <b-progress
              v-if="fillPercentage <= 100"
              v-bind:value="fillPercentage"
              v-bind:max="100"
              v-bind:variant="!isRPPS ? 'info': 'secondary'"
              striped
              show-value
            ></b-progress>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'WorkRecordItem',

  props: {
    item: {
      type: Object,
      required: true,
    }
  },

  data() {
    return {
      isRPPS: this.item.regimeType === 'RPPS'
    }
  },

  methods: {
    handleRegimeTypeChange() {
      const updatedItem = {
        ...this.item,
        regimeType: this.isRPPS ? 'RPPS' : 'RGPS'
      };
      
      this.$emit('regimeTypeChange', updatedItem);
    }
  },

  computed: {
    showRuralRppsWarning() {
      return this.item && this.item.isRuralTime && this.item.regimeType === 'RPPS';
    },

    tags() {
      let tags = [];

      if (this.item.isPublicService) tags.push({ name: "Serviço público" });
      if (this.item.isTeaching) tags.push({ name: "Magistério" });
      if (this.item.isCurrentCareer) tags.push({ name: "Carreira Atual" });
      if (this.item.isCurrentPosition) tags.push({ name: "Cargo Atual" });
      if (this.item.isPoliceTime) tags.push({ name: "Tempo Polícia" });
      if (this.item.isRuralTime) tags.push({ name: "Tempo Rural" });

      if (this.item.isDisabled && this.item.disabledLevel) {
        let text = "Com Deficiência";

        switch(this.item.disabledLevel) {
          case "low":
            text += " Leve";
            break;
          case "medium":
            text += " Moderada";
            break;
          case "high":
            text += " Grave";
            break;
        }

        tags.push({ name: text });
      }

      if (this.item.isSpecialTime) {
        if (this.item.specialLevel) {
          tags.push({ name: `Tempo Especial - ${this.item.specialLevel}` });
        } else {
          tags.push({ name: "Tempo Especial" });
        }
      }

      // if (tags.length > 3) {
      //   const extras = tags.slice(3, tags.length);
      //   let extraItems = extras.length;
      //   tags = tags.slice(0, 3);
        
      //   tags.push({ name: `+${extraItems}`, tooltip: extras.map(extra => `${extra.name}`).toString("") });
      // }

      return tags;
    },

    hasMinSalaryWarnings() {
      return this.salaries.some(s => s.warnings && s.warnings.includes('MIN_SALARY'));
    },

    ingressDate() {
      return moment(this.item.ingressDate).utc().format('DD/MM/YYYY');
    },

    egressDate() {
      return moment(this.item.egressDate).utc().format('DD/MM/YYYY');
    },

    canAddition() {
      if (moment(this.item.ingressDate).isAfter(moment("1998-12-16"))) return false;

      return true;
    },  

    salaries() {
      return this.item.salaries || [];
    },

    total() {
      // Meses e 13º contados por MÊS-CALENDÁRIO (startOf/endOf month), nunca pelo
      // dia: o loop antigo de dezembros andava a partir do DIA do ingresso e
      // comparava com o egresso cru — vínculo terminando em dezembro num dia
      // anterior ao dia do ingresso perdia o 13º daquele ano, o total ficava
      // menor que as remunerações e o card estourava >100% exibindo
      // "Data de início e término inválidas" (caso do vínculo fatiado, 22/07).
      let start = moment(this.item.ingressDate).startOf('month');

      if (start.isBefore('1994-07-01')) {
        start = moment('1994-07-01');
      }

      const end = moment(this.item.egressDate).endOf('month');
      let months = 0;
      let decemberMonths = 0;

      while (start.isSameOrBefore(end)) {
        months++;
        if (start.month() === 11) {
          decemberMonths++;
        }
        start.add(1, 'month');
      }

      return months + decemberMonths;
    },

    fillNumber() {
      const { salaries } = this;
      return salaries.filter((s) => s.value).length;
    },

    fillPercentage() {
      const { salaries, total, fillNumber } = this;

      if (total === 0) return 100;
      if (!salaries.length) return 0;

      const percentage = Math.round((fillNumber / total) * 100);

      return percentage;
    },

    completed() {
      return this.fillPercentage === 100;
    },

    rgpsWarning() {
      let warning = false;

      if (this.item.regimeType === 'RGPS') {
        if (moment(this.item.ingressDate).isAfter('2019-11-14')) {
          const salaryOnIngress = this.item.salaries ? this.item.salaries.find(s => s.month === moment(this.item.ingressDate).format('MM') && s.year === moment(this.item.ingressDate).format('YYYY')) : null;
          if (salaryOnIngress && salaryOnIngress.value > 0 && salaryOnIngress.warnings && salaryOnIngress.warnings.includes('MIN_SALARY')) {
            warning = false;
          } else {
            warning = true;
          }
        }
        
        if (moment(this.item.egressDate).isAfter('2019-11-14')) {
          const salaryOnEgress = this.item.salaries ? this.item.salaries.find(s => s.month === moment(this.item.egressDate).format('MM') && s.year === moment(this.item.egressDate).format('YYYY')) : null;
          if (salaryOnEgress && salaryOnEgress.value > 0 && salaryOnEgress.warnings && salaryOnEgress.warnings.includes('MIN_SALARY')) {
            warning = false;
          } else {
            warning = true;
          }
        }
      }

      return warning;
    },

    duration() {
      let { ingressDate, egressDate, regimeType } = this.item;

      if (regimeType === 'RGPS') {
        if (moment(ingressDate).isAfter('2019-11-14')) {
          const salaryOnIngress = this.item.salaries ? this.item.salaries.find(s => s.month === moment(this.item.ingressDate).format('MM') && s.year === moment(this.item.ingressDate).format('YYYY')) : null;
          if (salaryOnIngress && salaryOnIngress.value > 0 && salaryOnIngress.warnings && salaryOnIngress.warnings.includes('MIN_SALARY')) {

          } else {
            ingressDate = moment(ingressDate).startOf('month');
          }
        }
        
        if (moment(egressDate).isAfter('2019-11-14')) {
          const salaryOnEgress = this.item.salaries ? this.item.salaries.find(s => s.month === moment(this.item.egressDate).format('MM') && s.year === moment(this.item.egressDate).format('YYYY')) : null;
          if (salaryOnEgress && salaryOnEgress.value > 0 && salaryOnEgress.warnings && salaryOnEgress.warnings.includes('MIN_SALARY')) {

          } else {
            egressDate = moment(egressDate).endOf('month');
          }
        }
      }

      // using moment duration
      const duration = moment.duration(moment(egressDate).diff(moment(ingressDate))).add(1, 'day');
      const years = duration.years();
      const months = duration.months();
      const days = duration.days();

      let yearsString = years > 1 ? 'anos' : 'ano';
      let monthsString = months > 1 ? 'meses' : 'mês';
      let daysString = days > 1 ? 'dias' : 'dia';

      return `${years} ${yearsString} e ${months} ${monthsString} e ${days} ${daysString}`;
    },
  },
}
</script>

<style scoped>
.bg-orange-light {
  background-color: #fff3e0 !important;
}

.border-orange {
  border-color: #ff9800 !important;
}

.text-orange {
  color: #ff9800 !important;
}

.badge-orange {
  background-color: #ff9800 !important;
  color: white !important;
}

::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #ff9800;
  border-color: #ff9800;
}
</style>
